import React from 'react';
import { useGlobalData } from '../contexts/GlobalDataContext';
import { Loading as BaseLoading } from '@teko/ds-desktop';

interface PreLoadProps {
  height: number | string;
  isLoading: boolean;
}

interface LoadingProps {
  isLoading: boolean;
  children: React.ReactNode;
  top?: number;
}

export const Loading: React.FC<LoadingProps> = ({
  isLoading,
  children,
}: LoadingProps) => {
  const { logo } = useGlobalData();
  return (
    <BaseLoading
      isLoading={isLoading}
      logo={(logo?.loading || logo?.lite)?.path}
    >
      {children}
    </BaseLoading>
  );
};

export const PreLoad: React.FC<PreLoadProps> = ({
  isLoading,
  height,
}: PreLoadProps) => {
  const { logo } = useGlobalData();
  return (
    <BaseLoading
      isLoading={isLoading}
      style={{ height: typeof height === 'number' ? `${height}px` : height }}
      logo={(logo?.loading || logo?.lite)?.path}
    />
  );
};
